/* @flow */

import React from 'react';
import { withRouter } from 'next/router';
import styled from 'styled-components';

import withI18n from '../../utils/withI18n';
import FlexBox from '../FlexBox';

import AboutNav from './about-nav';
import About from './About/about';
import Careers from '../career';
import Press from './Press/press';
import Community from '../ContactUs/Community';
import Ecosystem from './Ecosystem/ecosystem';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  position: relative;
`;

type Props = {
  i18n: Object,
  router: Object,
};
export default
@withRouter
@withI18n
class Abouts extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    router: { pathname: '' },
  };

  render() {
    const {
      router: { pathname },
    } = this.props;
    return (
      <WrapperBox direction="column">
        {pathname !== '/ecosystem' && <AboutNav />}
        {pathname === '/about' && <About />}
        {pathname === '/career' && <Careers />}
        {pathname === '/press' && <Press />}
        {pathname === '/community' && <Community />}
        {pathname === '/ecosystem' && <Ecosystem />}
      </WrapperBox>
    );
  }
}
